import { Alert } from "@cloudscape-design/components";
import React from 'react';

interface VideoPreviewProps {
    apiUrl: string;
}

export const VideoPreview = ({ apiUrl }: VideoPreviewProps) => {
    if (!apiUrl) return <Alert type="error">No URL provided</Alert>;

    return (
        <div style={{
            position: 'relative',
            paddingTop: '56.25%',
            backgroundColor: '#000',
            borderRadius: '8px',
            overflow: 'hidden'
        }}>
            <video
                controls
                autoPlay
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                }}
                // This is the "Magic": we force the browser to treat 
                // the weird API URL as an mp4 stream.
                onLoadedData={() => console.log("Video loaded successfully")}
                onError={(e) => console.error("Native Video Error:", e)}
            >
                <source src={apiUrl} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};